// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

html,
body {
  height: 100%;
  width: 100%;
  border: none;
  margin: 0;
  padding: 0;
   
}

pre,
fieldset,
table {
  border: 0;
}

table, td {width: 100%;
border: 1px solid #707070;}


h1,
h2,
h3 {
  margin: 0;
  padding: 0;
   
	margin-bottom: 10px; 
}

h1 {
font-size: 20px;
 
font-weight: 400;
}


h2 {
  font-size: 15px;
   
font-weight: 500;
}


h3 {
  font-size: 15px;
   
font-weight: 300;
}


.color-accent,
.color-accent-hover:hover,
.color-accent-hover:focus,
:root .has-accent-color,
.has-drop-cap:not(:focus):first-letter,
.wp-block-button.is-style-outline,
a {
  color: #707070;
}


.welcome-header
{
	line-height: 60px;
	vertical-align: middle;
	padding-left: 28px;	
}

.company-pages {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.content-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.first {
	width: 200px;
}


.second {
	width: calc(100% - 220px);
}

.first-smaller {
	width: 70px;
}


.second-smaller {
	width: calc(100% - 200px);
}

.third-smaller {
	width: 60px;
}

.mission-text {
    margin-top: 10px;
    margin-bottom: 10px;
}

.button-container {
    display: flex;
    align-items: center;
    gap: 10px;
}


.company-pages textarea {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-sizing: border-box;
	height: 300px;
}

.press-pages {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.presslist {
    padding-bottom: 50px;
}


.section-header, .input-section, .button-section {
    display: flex;
    flex-direction: column;
    gap: 3px;
	margin-bottom: 0px;
}


.input-section h2 {
	margin-bottom: 0px;
}

.input-section input, .input-section select {
	width: 200px;
	padding: 5px;
	margin-left: 5px;
}



.save {
    background: #ececef;
    color: #353740;
    padding: 9px 13px;
    border-radius: 8px;
    border: none; 
    transition: transform 0.3s;
    cursor: pointer;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    letter-spacing: normal;
    margin-left: 3px;
	margin-right: 3px;
}

.save:hover {
    background: #e2e2e7;
}



.tiny_button {
    color: #0028FF;
    padding: 2px 5px;
    border: none; 
    transition: transform 0.3s;
    cursor: pointer;
    font-size: 13px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    letter-spacing: normal;
    margin-left: 3px;
	margin-right: 3px;
}

.tiny_button:hover {
    color: #000000;
}



.editor-button {
    background: linear-gradient(145deg, #0028FF, #0038FF); 
    color: #ffffff;
    padding: 7px 11px;
    border-radius: 5px;
    border: none; 
    transition: transform 0.3s;
    cursor: pointer;
    font-size: 17px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    letter-spacing: normal;
    margin-left: 3px;
	margin-right: 3px;
}

.editor-button:hover {
    transform: scale(1.04);
}

.collaborators-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  width: 100%;
  font-family: 'Arial', sans-serif;
}

.collaborators-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  border-bottom: 5px solid #f4f4f4;
  background-color: #FFFFFF;
}

.collaborators-list li:hover {
  background-color: #f4f4f4;
}

.collaborators-list li span {
  margin-right: 10px;
  color: #333;
  font-size: 14px;
}


.pending {
  background-color: #fff3cd;
}

.rewrite {
  background-color: #cce5ff;
}

.commented {
  background-color: #d4edda;
}

.collaborated {
  background-color: #f8d7da;
}


option {
  padding: 5px;
}


.press-pages textarea {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-sizing: border-box;
	height: 150px;
}

.save1 {
    display: inline-block;
    text-decoration: none;
    text-align: center;
    border: 1px solid #0028ff;
    color: #0028ff;
    background: #ffffff;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 5px;
    font-size: 15px;
    transition: background .3s ease-in-out;
    padding: 5px 15px 5px 15px;
	margin-right: 10px;
}



.blueButton {
    display: inline-block;
    text-decoration: none;
    text-align: center;
    border: 1px solid #0028ff;
    color: #ffffff;
    background: #0028ff;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 5px;
    font-size: 15px;
    transition: background .3s ease-in-out;
    padding: 5px 15px 5px 15px;
	margin-right: 10px;
}

.blueButton:hover {
   
    color: #0028ff;
    background: #ffffff;
  
}



.save-active {
    display: inline-block;
    text-decoration: none;
    text-align: center;
    border: 1px solid #0028ff;
    color: #0028ff;
    background: #e0e0e0;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 5px;
    font-size: 15px;
    transition: background .3s ease-in-out;
    padding: 5px 15px 5px 15px;
	margin-right: 10px;
}

.save1:hover {
color: #ffffff;
   background: #0028ff;

}

.vertical-center {
	display: flex; 
	align-items: center;
}

label {
  font-size: 14px;
  font-weight: 300;
			 
}

input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.icons button {
	background-color: transparent;
	border: 0px;
	cursor: pointer;
}

.icons button:hover {
	opacity: 0.3;
}



.icons img {
	height: 15px;
	width: auto;
}

.icons .enabledButton:hover {
	opacity: 0.3;
}


p {
	line-height: 1.4;
    font-weight: 300;
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

}


p.small {
  font-size: 15px;
}

p.big {
  font-size: 20px;
}


.header-item span {
      font-size: 18px;
	line-height: 1.4;
  font-weight: 300;
 
}

.creator-info span {
  font-size: 15px;
  line-height: 1.4;
  font-weight: 300;
  display: block;
}

li,
a,
li a {
  color: #707070;
  font-weight: 300;
  text-decoration: none;
  
list-style-type: none;
  padding: 0;
  margin: 0;
}

a:hover,
li a:hover {
  text-decoration: none;
			 

}

td {
    padding-right: 7px;
	  vertical-align: middle;
	  font-size: 18px;
	line-height: 1.4;
	font-weight: 300;
  	 

}




.headerbar {
  display: grid;
  position: fixed;
  top: 0px;
	left: 150px;
  z-index: 100;
  height: 60px;
  width: 100%;
  background-color: #ffffff;
  font-weight: 400;
    font-size: 18px;
	line-height: 1.4;
  visibility: visible;
border-bottom: thin #DBDBDB solid;
	box-shadow: 0 1px 3px rgba(0,0,0,.1);
}

.leftpart {
  height: 100%; 
}

.middlepart {
  height: 100%; 
}

.rightpart {
  height: 100%; 
}

.headerbar li {
  position: relative;
  display: inline;
  color: #ffffff;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 28px;
}

.headerbar p {
  position: relative;
  display: inline;
  color: #ffffff;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 28px;
    font-size: 14px;
	line-height: 1.4;
}


.headerbar li a {
  color: #ffffff;
  font-size: 14px;
}

.headerbar li a:hover {
  color: #ffffff;
  font-size: 14px;
  text-decoration: underline;
}

.headerbar a {
  color: #ffffff;
  text-decoration: none;
}

.headerbar a:hover {
  text-decoration: underline;
}





.bottombar {
  position: fixed;
  bottom: 0;
  z-index: 100;
  min-height: 40px;
  padding: 10px 5% 10px;
  width: 90%;
  background-color: #ffffff;
  font-weight: 400;
  font-size: 15px;
  visibility: visible;
  align-content: center;
  text-align: center;
}

.bottombar li {
  position: relative;
  display: inline;
  color: #707070;
  margin: 0 3px;
  padding: 0 2px 4px;
  line-height: 30px;
}

.bottombar li a {
  color: #707070;
  font-size: 14px;
}

.bottombar li a:hover {
  color: #707070;
  font-size: 14px;
  text-decoration: underline;
}

.bottombar a {
  color: #707070;
  text-decoration: none;
}

.bottombar a:hover {
  text-decoration: underline;
}


.content-background {
  position: absolute;
  left: 140px;
  right: 0px;
  z-index: 99;
  top: 40px;
	bottom: 0px;
}

.content {
  position: absolute;
  left: 20px;
  right: 10px;
  z-index: 99;
  top: 30px;
	bottom: 30px;
 }

.inner {
   background-color: #ffffff;
	box-shadow: 0 2px 4px 0 rgba(220,220,220,.5);
border: thin #DBDBDB solid;
	overflow: auto;
	scroll-behavior: auto;
	padding: 25px;
	height: calc(100% - 50px);
}

.sub-inner {
  margin-bottom: 10px; 
	background-color: #ffffff;
	box-shadow: 0 2px 4px 0 rgba(220,220,220,.5);
border: thin #DBDBDB solid;
	overflow: auto;
	scroll-behavior: auto;
	padding:15px;
}

.sub-inner textarea
{
	    width: 100%;
    min-height: 70px;
    max-height: 95px;
    padding: 3px;
border: 1px solid #DBDBDB;
	resize: none;
    box-sizing: border-box;
    overflow-y: auto;
    transition: height 0.2s ease-in-out; 
	transition: border-color 0.3s;
	font-size: 15px;
	   
font-weight: 300;
	color: #333;
}


.editor-textarea:focus,
.editor-input:focus {
    border: 1px solid #0028ff;
    outline: none;
}

.sub-inner input
{
	margin-bottom: 4px;
	margin-right: 4px;
	max-width: 60%;
}

.sub-inner select
{
	margin-bottom: 4px;
	margin-right: 4px;
	max-width: 60%;
}

.full-width {
    width: calc(100% - 50px);
    float: left;
}

.half-width {
    width: 50%;
    float: left;
}

.one-thirds {
    width: calc(100% - 60% - 104px);
    float: right;
}

.two-thirds {
    width: 60%;
    float: left;
	margin-right: 20px;
}


#chat-history {
            flex: 2 1;
             padding: 3px 5px;
  font-size: 20px;
  border: solid 1px;
  border-color: #707070;
  margin-top: 10px;
	 bottom: 50px;
	 max-height: 450px;
          overflow-y: scroll;
	
	overflow-anchor: none;
        }


ul {
  display: block;
  list-style-type: disc;
  margin: 0;
  padding-inline-start: 0;
}


.logo {
  top: 20px;
  left: 15px;
  width: 120px;
  position: fixed;
  z-index: 1001;
}


.logo img {
	width: 100%;
	height: auto;
}

.language-switcher {
  position: fixed;
  right: 60px;
  top: 15px;
	height: 20px;
  z-index: 1000;
  cursor: pointer;
}

.user {
  position: fixed;
  right: 20px;
  top: 20px;
	height: 20px;
	width: 20px;
  z-index: 1000;
  cursor: pointer;
}


.user:before {
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
  filter: blur(0px);
  width: calc(100% + 3px);
  height: calc(100% + 3px);
  background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
  background-size: 200%;
  animation: glowing 20s linear infinite;
  opacity: 0;
  z-index: -1;
  border-radius: 0px;
}

.user:hover {
  color: #707070;
  text-decoration: none;
}

.user:hover:before {
  opacity: 1;
  filter: blur(10px);
}

.user img {
  height: 100%;
  width: auto;
}

.dropdown-content {
  position: absolute;
  right: 30px;
  top: 50px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
  transform: translateY(-20px);
  transition: all 0.5s ease, opacity 0.3s ease;
  opacity: 0;
  visibility: hidden;
  border: 1px solid #ddd;
  z-index: 170707000000;
}


.dropdown-content.slide-in {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

/* Dropdown Section */
.dropdown-section {
  padding: 15px;
  display: flex;
  flex-direction: column; /* Aligns items vertically */
  gap: 5px; /* Adds space between items */
}


.dropdown-section a {
  background-color: #ffffff;
  border: 1px solid #ddd;
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  transition: background-color 0.3s, color 0.3s;
}

.dropdown-section a:hover {
  background-color: #e6e6e6;
  color: #707070;
}

.dropdown-section a.active {
  background-color: #d3d3d3;
  color: #707070;
}

.dropdown-section:last-child {
  border-bottom: none;
}

.dropdown-section-bottom button {
  background-color: #ffffff;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 15px;
  color: #333;
  transition: background-color 0.3s;
	cursor: pointer;
	font-weight: 400;
}

.dropdown-section-bottom button:hover {
  background-color: #eaeaea;
}

.dropdown-section-bottom a {
  background-color: #ffffff;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 15px;
  color: #333;
  transition: background-color 0.3s;
	cursor: pointer;
	font-weight: 400;
}

.dropdown-section-bottom a:hover {
  background-color: #eaeaea;
}


.half td {
	min-width: 0px;
}

.main-nav-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 150px;
  padding-top: 60px; 
  z-index: 999; 
  height: 100%; 
  border-right: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.main-nav, .one, .two, .three {
  position: relative;
  left: 0;
  z-index: 1001;
  width: 150px;
}

.one, .two, .three {
  padding-top: 20px; 
  margin-bottom: 10px;
}

.main-nav a {
  font-size: 13px;
  color: #333;
  padding: 10px 15px;
  margin: 3px 5px;
  border-radius: 4px;
  display: block;
  transition: all 0.3s ease;
   
}



.main-nav a:hover, .main-nav .active {
  color: #0028ff; 
  background-color: #e0e0e0;
  border-right: 4px solid #0028ff;
  text-decoration: none;
	font-weight: 300;
}


.main-nav button.main-nav-disabled {
font-size: 13px;
    color: #0028ff;
    padding: 10px 15px;
    margin: 3px 5px;
    border-radius: 4px;
    display: block;
    transition: all 0.3s ease;
     
	border: 0px;
	font-weight: 300;
	  width: calc(100% - 10px);
	text-align: left;
opacity: 0.5;
}

.main-nav button.main-nav-disabled:hover {
  color: #0028ff; 
  background-color: #e0e0e0;
  border-right: 4px solid #0028ff;
  text-decoration: none;
	font-weight: 300;
}

.main-nav .active:hover {
  color: #ffffff; 
  background-color: #0028ff;
  border-right: 4px solid #e0e0e0;
  text-decoration: none;
}

.main-nav button {
  font-size: 13px;
  color: #0028ff;
  background-color: transparent;
  border: 1px solid #e0e0e0;
  padding: 5px 2px;
  width: calc(100% - 30px);
  margin: 2px 20px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
	cursor: pointer;
}

.main-nav button:hover {
  color: #0028ff;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

@keyframes glowing {
  0% { background-position: 0 0; }
  50% { background-position: 400% 0; }
  100% { background-position: 0 0; }
}

   
.tab-controls {
    display: flex; 
    flex-direction: column; 
    align-items: flex-start; 
    border-bottom: 0px solid #d3d3d3;
}

.tab-controls button {
     background: #FFFFFF;
    color: #333333;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #d3d3d3; 
    transition: transform 0.3s;
    cursor: pointer;
    font-size: 13px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    letter-spacing: normal;
	margin: 3px;
}


.tab-controls button:hover {
    background-color: #e6e6e6;
}

.tab-controls button.active {
    background-color: #d3d3d3; 
    color: #ffffff;
}

.tab-controls button.active:hover {
    background-color: #cccccc;
}



.glowing {
    display: inline-block;
    text-decoration: none;
    text-align: center;
    line-height: 40px;
    min-width: 160px;
    height: 40px;
    border: 1px solid #707070;
    color: #707070;
    background: #fff;
    cursor: pointer;
    position: relative;
    z-index: 0;
    border-radius: 10px;
    font-size: 15px;
    transition: background .3s ease-in-out;
    padding-left: 10px;
	padding-right: 10px;
}

.glowing:before {
    content: '';
    background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
    position: absolute;
    top: -2px;
    left:-2px;
    background-size: 400%;
    z-index: -1;
    filter: blur(5px);
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    animation: glowing 20s linear infinite;
    opacity: 1;  /* Adjusted this to always show the glow */
    border-radius: 10px;
}

.glowing:active {
    color: #707070;
}

.glowing:hover:before {
    filter: blur(20px);  /* Adjusted this to increase the glow spread on hover */
}

.glowing:after {
    z-index: -1;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    left: 0;
    top: 0;
    border-radius: 10px;
}

@keyframes glowing {
    0% { background-position: 0 0; }
    50% { background-position: 400% 0; }
    100% { background-position: 0 0; }
}



.publicapproval-header, .publicapproval-item {
  display: flex;
  align-items: flex-start; /* Updated this line */
  border-bottom: 0px solid #ccc;
  padding: 0px 5px 0px 5px;
  gap: 20px;
}

.publicapproval-header .header-item:first-child, .publicapproval-item > div:first-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(60%);
  height: 500px;
  overflow-y: auto;
  padding-right: 15px;
}

.publicapproval-header .header-item:nth-child(2), .publicapproval-item > div:nth-child(2) {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(40% - 25px);
}



.modal-alert {
  display: flex;
  flex-direction: column; /* Changes layout to vertical */
  align-items: center; /* Horizontally centers items in the alert */
  justify-content: flex-start; /* Aligns items to the start of the container */
  border-bottom: 0px solid #ccc;
  padding: 25px;
  gap: 25px; /* Space between items */
	background-color: #ffffff;
	border-radius: 8px;
}

.modal-alert-item {
  display: flex;
  align-items: center; /* Center items vertically within each .modal-alert-item */
  justify-content: center;
  width: 350px; /* Sets a fixed width for each item */
}

/* Maintains the spacing between buttons if they are in the same .modal-alert-item */
.modal-alert-item > div {
  display: flex;
  gap: 10px; /* Adjust the space between the buttons */
}


.modal-alert-backdrop {
  position: fixed;
  top: 0;
  left: 150px; /* Adjusted from 150px to 0 to cover the full screen */
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}



.companydetails-header, .companydetails-item {
  display: flex;
  align-items: center;
  border-bottom: 0px solid #ccc;
  padding: 0px 5px 0px 5px;
gap: 5px;
}


.companydetails-item:hover
{
	background-color: #F5F5F5;
}

.companydetails-header .header-item:first-child, .companydetails-item > div:first-child {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(40% - 15px);
}

.companydetails-header .header-item:nth-child(2), .companydetails-item > div:nth-child(2) {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(60%);
}


.companydetails-header-four, .companydetails-item-four {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 5px 5px 5px 5px;
gap: 5px;
}


.companydetails-item-four:hover
{
	background-color: #F5F5F5;
}

.companydetails-header-four .header-item:first-child, .companydetails-item-four > div:first-child {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(100% - 350px);
	 text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.companydetails-header-four .header-item:nth-child(2), .companydetails-item-four > div:nth-child(2) {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(170px);
	 text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.companydetails-header-four .header-item:nth-child(3), .companydetails-item-four > div:nth-child(3) {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(120px);
}

.companydetails-header-four .header-item:nth-child(4), .companydetails-item-four > div:nth-child(4) {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(15px);
}

.companydetails-header-four .header-item:nth-child(4), .companydetails-item-four > div:nth-child(4) {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(15px);
}




.press-release-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}



.header-item {
  padding-bottom: 5px;
	     
	 text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.article-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}


.article-header, .article-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 5px 5px 5px 5px;
gap: 5px;
}

.article-header {
  position: sticky;
  top: 0;
	background-color: #ffffff;
}


.article-item:hover
{
	background-color: #F5F5F5;
}


.article-header .header-item:first-child, .article-item > div:first-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 390px);
}

.article-header .header-item:nth-child(2), .article-item > div:nth-child(2) {
  flex: 0 0 90px;
}

.article-header .header-item:nth-child(3), .article-item > div:nth-child(3) {
  flex: 0 0 80px;
}

.article-header .header-item:nth-child(4), .article-item > div:nth-child(4) {
  flex: 0 0 210px;
}

.article-header h2 {
font-size: 15px;
     
    font-weight: 500;
    padding: 0;
    margin-bottom: 0px;
}


.press-release-header, .press-release-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 5px 5px 5px 5px;
gap: 5px;
}


.press-release-header {
	background-color: #ffffff;
  position: sticky;
  top: 0; /* Adjust this value as needed */
}


.press-release-item:hover
{
	background-color: #F5F5F5;
}

.press-release-header .header-item:first-child, .press-release-item > div:first-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 575px);
}

.press-release-header .header-item:nth-child(2), .press-release-item > div:nth-child(2) {
  flex: 0 0 90px;
}

.press-release-header .header-item:nth-child(3), .press-release-item > div:nth-child(3) {
  flex: 0 0 90px;
}

.press-release-header .header-item:nth-child(4), .press-release-item > div:nth-child(4) {
  flex: 0 0 90px;
}

.press-release-header .header-item:nth-child(5), .press-release-item > div:nth-child(5) {
  flex: 0 0 80px;
}

.press-release-header .header-item:nth-child(6), .press-release-item > div:nth-child(6) {
  flex: 0 0 210px;
}

.press-release-header h2 {
font-size: 15px;
     
    font-weight: 500;
    padding: 0;
    margin-bottom: 0px;
}

.translations p, div {
    font-size: 15px;
    line-height: 1;
    font-weight: 300;
     
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}


.corporatetext-header, .corporatetext-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 5px 5px 5px 5px;
gap: 5px;
}

.blogpost-header {
  position: sticky;
  top: 0;
	background-color: #ffffff;
}

.corporatetext-header h2 {
font-size: 15px;
     
    font-weight: 500;
    padding: 0;
    margin-bottom: 0px;
}

.corporatetext-item:hover
{
	background-color: #F5F5F5;
}


.corporatetext-header .header-item:first-child, .corporatetext-item > div:first-child {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 575px);
}

.corporatetext-header .header-item:nth-child(2), .corporatetext-item > div:nth-child(2) {
   flex: 0 0 90px;
}

.corporatetext-header .header-item:nth-child(3), .corporatetext-item > div:nth-child(3) {
  flex: 0 0 80px;
}

.corporatetext-header .header-item:nth-child(4), .corporatetext-item > div:nth-child(4) {
  flex: 0 0 90px;
}

.corporatetext-header .header-item:nth-child(5), .corporatetext-item > div:nth-child(5) {
  flex: 0 0 80px;
}

.corporatetext-header .header-item:nth-child(6), .corporatetext-item > div:nth-child(6) {
  flex: 0 0 210px;
}




.blogpost-header, .blogpost-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 5px 5px 5px 5px;
gap: 5px;
}

.blogpost-header h2 {
font-size: 15px;
    font-weight: 500;
    padding: 0;
    margin-bottom: 0px;
}

.blogpost-header {
  position: sticky;
  top: 0;
	background-color: #ffffff;
}



.blogpost-item:hover
{
	background-color: #F5F5F5;
}

.blogpost-header .header-item:first-child, .blogpost-item > div:first-child {
flex-grow: 0;
flex-shrink: 0;
flex-basis: calc(100% - 390px);
}

.blogpost-header .header-item:nth-child(2), .blogpost-item > div:nth-child(2) {
flex: 0 0 90px;
}

.blogpost-header .header-item:nth-child(3), .blogpost-item > div:nth-child(3) {
  flex: 0 0 80px;
}

.blogpost-header .header-item:nth-child(4), .blogpost-item > div:nth-child(4) {
 flex: 0 0 210px;
}



.blogpost-item > div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.corporatetext-item > div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.press-release-item > div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.article-item > div {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shorten {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%; 
}


.modal-backdrop-edit {
    position: fixed;
    top: 50px;
    left: 120px;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;
}

.modal-edit-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 80%;
    width: 100%;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 600px;
    width: 100%;
}


.modal-backdrop-full {
    position: fixed;
    top: 0;
    left: 0px;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 150px;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.disabledButton {
    opacity: 0.3;
	cursor: pointer;
}

.disabledButton button:hover {
    opacity: 0.3;
}

.press-modal {
    position: fixed;
    top: 0;
    left: 150px;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-press-content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    padding: 20px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 120px;
    margin-bottom: 60px;
    text-align: left;
    overflow-y: auto;
	 display: flex;
    flex-direction: column;
    max-height: 80vh;
}

textarea:disabled {
	    cursor: default;
    background-color: #ffffff;
    color: #000000;
    border-color: #ffffff;
}

.sticky {
	position: sticky;
	padding: 8px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 500;
	background-color: #ffffff;
	font-color: #0028FF;
	  top: 0; 
	max-width: 130px;

}

.modal-button-bar {
 
    justify-content: space-between;
    background: #ffffff;
    padding-bottom: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid #ddd;
	position: sticky;
    top: 0;
    z-index: 10;
}

.modal-scrollable-content {
    overflow-y: auto;
    flex-grow: 1;
    padding: 10px;
}

.modal-header, .modal-body, .modal-footer {
    padding: 10px;
}


.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.close-press-button {
	float: right;
    background: none;
    border: none;
    font-size: 44px;
    cursor: pointer;
	margin-top: -12px;
}

.modal-body {
    text-align: left;
}

.press-release-date {
    font-style: italic;
    margin-bottom: 10px;
}

.press-release-text {
    line-height: 1.6;
}

.modal-footer {
    text-align: left;
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 10px;
	padding-bottom: 30px;
}



.subscription-container {
    max-width: 600px;
    margin: auto;
    text-align: center;
    font-family: 'Arial', sans-serif;
}

.toggle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    margin: 0 10px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
}

input:checked + .slider {
    background-color: #0028FF;
}

input:focus + .slider {
    box-shadow: 0 0 1px #0028FF;
}

input:checked + .slider:before {
    transform: translateX(26px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}


@media only screen and (max-width: 766px) {


.plans-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 5px;
}}
	
	
	@media only screen and (min-width: 767px) {


.plans-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
}

}
	
.plan {
	 display: grid;
  grid-template-rows: 50px 50px 50px;
    padding: 25px 10px 10px 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: transform 0.3s ease;
	text-align: center;
	margin: 5px;
}

.plan:hover {
    transform: scale(1.05);
    	 border: 1px solid #0028ff;
}

.plan h3 {
    margin: 0 0 10px 0;
}

.plan button {
    background-color: #0028ff;
    color: white;
    border: none;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 15px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 5px;
	 border: 1px solid #0028ff;
	    transition: background-color 0.7s ease;
	}

.plan button:hover {
    background-color: #ffffff;
	    color: #0028ff;
   

}

.inactive {
    color: #aaa;
}

.active {
    font-weight: bold;
}


.left
{
	text-align: left;
	align-content: left;
}


.vision-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.vision-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.vision-content {
  gap: 20px;
}

.vision-content textarea {
  margin-top: 10px;
	height: 150px;
}

.vision-instructions, .vision-text, .vision-button {
  flex: 1 1;
	margin-top: 10px;
	margin-bottom: 20px;
}


.content-section, .translations-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.translation-header, .translation-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.translation-row {
	padding-top: 10px;
	border-top: 1px solid #ddd;
}

.content-section {
	padding-top: 10px;
	padding-bottom: 10px;
	margin-bottom: 30px;
	border-bottom: 1px solid #ddd;

}

.translations {
    width: calc(100% - 20px);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
	border-bottom: 1px solid #dddddd;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 5px;
	padding-bottom: 5px;
}

.first-translations, .second-translations, .third-translations {
    display: flex;
    flex-direction: column;
    justify-content: center; 
    gap: 10px;
}

.first-translations {
    width: 120px;
	 overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.second-translations {
    width: calc(100% - 230px);
	 overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.third-translations {
 width: 90px;
	text-align: right;
}


.toggle-translations {
border-left: 1px solid #ffffff;
   }

.toggle-translations-btn {
    font-size: 12px;
     
    font-weight: 500;
    color: #0028ff;
	margin-right: 2px;
     border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    text-align: center;
    display: inline-block;
    margin: 0px;
border: 1px solid #ffffff;
}

.toggle-translations-btn:hover {
    color: #707070;
	border: 1px solid #707070;
}

.toggle-translations-btn:focus {
    outline: none;
}

.initial-info {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
}

.info-header {
    font-weight: bold;
    text-align: center;
}

.info-value {
    text-align: center;
}



.table-comments {
     margin-bottom: 10px;
	padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
}

.table-row-comments {
  	grid-template-columns: 100%; 

}


.table {
     margin-bottom: 0px;
  background-color: #ffffff;
	  position: sticky;
  top: 0;
}


.table p {
     font-size: 15px;
	
}

.table-header, .table-row {
    display: grid;
grid-template-columns: 10px calc(100% - 400px) 100px 80px 50px 110px; 
	gap: 10px;
    padding: 5px;
  align-items: center; 
}



.table-row {
   border-top: 1px solid #ccc;
		z-index: 1;

}


.table-row:hover
{
	background-color: #F5F5F5;
}



.header-approval, .header-collaboration {
    text-align: left;
	font-weight: 400;
	padding-bottom: 5px;
}

.row-approval {
  display: block;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


.row-collaboration {
  display: block;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


.detailed-info {
    background-color: #f4f4f4;
    padding: 10px;
	padding-right: 5px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-top: 10px;
	margin-bottom: 10px;
}

.detailed-info h4 {
    color: #333;
    margin-bottom: 10px;
}

.creator-info, .approvers-section, .comments-section {
    margin-bottom: 20px;
}

.approvers-section select {
    width: 150px;
}


.approvers-list, .comments-list {
    list-style-type: none;
    padding: 0;
}

.approvers-list li, .comments-list li {
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.approvers-list li.approved {
    border-left: 4px solid #0028ff;
}

.approvers-list li.pending {
    border-left: 4px solid orange;
}




.send-reminder-btn, .send-approval-requests-btn {
    background-color: #707070;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.send-reminder-btn:hover, .send-approval-requests-btn:hover {
    background-color: #333333;
}

.divider
{
	height: 20px;
}


.status-circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
}

.status-circle.approved {
    background-color: #0028ff;
}

.status-circle.not-approved {
    background-color: orange;
}

.status-circle.pending {
    background-color: orange; /* or any color you prefer */
}


.status-circle.collaborated {
    background-color: #0028ff;
}

.status-circle.not-collaborated {
    background-color: orange;
}


.corporatetext-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}



.input-group {
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 5px;
    font-weight: bold;
    color: var(--text-color);
}

.input-group input, .input-group textarea {
    padding: 10px;
    border: 1px solid var(--input-border-color);
    border-radius: 4px;
    background-color: var(--input-background);
}

.action-buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.process-button {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.process-button:hover {
    background-color: darken(var(--primary-color), 10%);
}

.process-button:disabled {
    background-color: #ccc;
}

.loading-spinner {
    border: 4px solid rgba(0,0,0,0.1);
    border-radius: 50%;
    border-top-color: var(--primary-color);
    width: 40px;
    height: 40px;
    animation: spin 2s linear infinite;
    margin: 20px auto;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.main-editor-container {
 position: relative;
    height: calc(100vh - 160px);
    overflow: hidden;

}

.scrollable-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: hidden;
    margin-bottom: 80px;
}

.editor-header, .editor {
    overflow-y: auto;
}

.editor-wrapper {
     position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;

}

.editor-result {
    position: relative;
    width: 100%;
     
    font-weight: 300;
    border: 0px;
    height: calc(100% - 35px);
   box-sizing: border-box;

}

.editor-result-full {
    position: relative;
    width: calc(100% - 5px);
     
    font-weight: 300;
    border: 0px;
   box-sizing: border-box;

}


.editor-result-text {
    position: relative;
    width: 100%;
    font-size: 20px;
     
    font-weight: 300;
    border: 0px;
    height: calc(100% - 10px);
    padding-bottom: 55px;
    box-sizing: border-box;
    line-height: 1.5em;
	padding-right: 15px;
}

.review {
    font-size: 15px;
    font-weight: 300;
    box-sizing: border-box;
    line-height: 1.5em;
	max-height: 250px;
	padding-bottom: 30px;
}


.review .headline {
     font-weight: 500;
	margin-bottom: 15px;
}


.editor-approver-text {
    position: relative;
    width: 100%;
    font-size: 20px;
     
    font-weight: 300;
    border: 0px;
    height: 370px;
    box-sizing: border-box;
    line-height: 1.5em;
	padding-right: 15px;
}


.editor-collaborator-text {
    position: relative;
    width: 100%;
    font-size: 20px;
     
    font-weight: 300;
    border: 0px;
    height: 450px;
    box-sizing: border-box;
    line-height: 1.5em;
	padding-right: 15px;
}


.editor-header {
    text-align: center;
    padding-bottom: 20px;
}


.editor-content {
    position: sticky;
    bottom: 0;
}

.editor-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px; 
}

.editor-input {
    width: 100%;
    padding: 0px;
    border: 0px solid #ccc;
     resize: none;
    box-sizing: border-box;
      transition: height 0.2s ease-in-out; 
	transition: border-color 0.3s;
	font-size: 20px;
	   
font-weight: 500;
}





.editor-input:focus {
    border: 0px solid #0028ff;
    outline: none;
}


.editor-textarea:focus {
    border: 1px solid #0028ff;
    outline: none;
}

.editor-section input:focus {
    border: 1px solid #0028ff;
    outline: none;
}

.editor-section-button {
    flex-basis: 20%;
    display: flex;
    justify-content: center; /* Align button in the available space */
}


.textarea-container {
    flex-grow: 1; 
    width: 40%;
}

.textarea-container-two:first-child {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(50% - 70px);
}

.textarea-container-two:nth-child(2) {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 70px);
}

.textarea-container-two:nth-child(3) {
  flex: 0 0 120px;
}

.textarea-container-one:first-child {
 flex-grow: 0;
 flex-shrink: 0;
 flex-basis: calc(100% - 120px);
}

.textarea-container-one:nth-child(2) {
  flex: 0 0 120px;
}


.public-comment-textarea {
    width: 100%;
    min-height: 70px;
    height: 300px;
    padding: 3px;
    border: 1px solid #ccc;
     resize: none;
    box-sizing: border-box;
    overflow-y: auto;
    transition: height 0.2s ease-in-out; 
	transition: border-color 0.3s;
	font-size: 15px;
	   
font-weight: 300;
	color: #333;
}



.comment-textarea {
    width: 100%;
    min-height: 105px;
    padding: 3px;
    border: 1px solid #ccc;
     resize: none;
    box-sizing: border-box;
    overflow-y: auto;
	transition: border-color 0.3s;
	font-size: 15px;
	font-weight: 300;
	color: #333;
	padding-left: 5px;
	padding-right: 5px;
}


.comment-textarea:focus {
    border: 1px solid #0028FF;
 }


::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-thumb {
    background-color: #0028ff;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #0028ff;
}



.editor-textarea::placeholder {
    color: #909090;
}

.editor-result-text::placeholder {
    color: #0028ff;
    font-weight: 300;
font-size: 20px;
	line-height: 1.5em;
	   
}

textarea {
  resize: none;
	 outline: none;
}

.span-added {
	color: #0028ff; 
	font-weight:bold; 
	padding:0 4px;
	border: 1px solid #0028ff;
}

.span-removed {
	background-color:#ccc; 
	color:#0028ff; 
	text-decoration:line-through; 
	padding:0 4px;
}

.span-changed {
background-color:#ffff99; 
	color:#cc9900; 
	text-decoration:underline; 
	padding:0 4px;
}

.span-else {

	padding:0 2px;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;EAEE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;;AAEZ;;AAEA;;;EAGE,SAAS;AACX;;AAEA,WAAW,WAAW;AACtB,yBAAyB,CAAC;;;AAG1B;;;EAGE,SAAS;EACT,UAAU;;CAEX,mBAAmB;AACpB;;AAEA;AACA,eAAe;;AAEf,gBAAgB;AAChB;;;AAGA;EACE,eAAe;;AAEjB,gBAAgB;AAChB;;;AAGA;EACE,eAAe;;AAEjB,gBAAgB;AAChB;;;AAGA;;;;;;;EAOE,cAAc;AAChB;;;AAGA;;CAEC,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;CACC,YAAY;AACb;;;AAGA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;;AAGA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;CACzB,aAAa;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;CACX,kBAAkB;AACnB;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,gBAAgB;AACjB;;;;AAIA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;CACnB,iBAAiB;AAClB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;CACnB,iBAAiB;AAClB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;IACI,qDAAqD;IACrD,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;CACnB,iBAAiB;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;CACzB,aAAa;AACd;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,0BAA0B;CAC7B,kBAAkB;AACnB;;;;AAIA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,0BAA0B;CAC7B,kBAAkB;AACnB;;AAEA;;IAEI,cAAc;IACd,mBAAmB;;AAEvB;;;;AAIA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,0BAA0B;CAC7B,kBAAkB;AACnB;;AAEA;AACA,cAAc;GACX,mBAAmB;;AAEtB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;;;AAIA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;;AAGA;CACC,gBAAgB;IACb,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;;AAE1B;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;;AAGA;MACM,eAAe;CACpB,gBAAgB;EACf,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;;AAEvB,qBAAqB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,qBAAqB;;;AAGvB;;AAEA;IACI,kBAAkB;GACnB,sBAAsB;GACtB,eAAe;CACjB,gBAAgB;CAChB,gBAAgB;;;AAGjB;;;;;AAKA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;CACT,WAAW;EACV,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gBAAgB;IACd,eAAe;CAClB,gBAAgB;EACf,mBAAmB;AACrB,iCAAiC;CAChC,oCAAoC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;IACf,eAAe;CAClB,gBAAgB;AACjB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;;;;AAMA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,SAAS;CACV,WAAW;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;CACV,YAAY;CACZ;;AAED;GACG,yBAAyB;CAC3B,4CAA4C;AAC7C,0BAA0B;CACzB,cAAc;CACd,qBAAqB;CACrB,aAAa;CACb,yBAAyB;AAC1B;;AAEA;EACE,mBAAmB;CACpB,yBAAyB;CACzB,4CAA4C;AAC7C,0BAA0B;CACzB,cAAc;CACd,qBAAqB;CACrB,YAAY;AACb;;AAEA;;KAEK,WAAW;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB,yBAAyB;CACxB,YAAY;IACT,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;CACtC,6BAA6B;CAC7B,eAAe;;AAEhB,gBAAgB;CACf,WAAW;AACZ;;;AAGA;;IAEI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;AACf;;AAEA;;CAEC,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;AACf;;AAEA;IACI,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;CACd,kBAAkB;AACnB;;;AAGA;YACY,SAAO;aACN,gBAAgB;EAC3B,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;UACT,kBAAkB;;CAE3B,qBAAqB;QACd;;;AAGR;EACE,cAAc;EACd,qBAAqB;EACrB,SAAS;EACT,uBAAuB;AACzB;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;;AAGA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;CACV,YAAY;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;CACV,YAAY;CACZ,WAAW;EACV,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,mHAAmH;EACnH,qBAAqB;EACrB,sCAAsC;EACtC,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,UAAU;EACV,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,QAAQ,EAAE,6BAA6B;AACzC;;;AAGA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iCAAiC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iCAAiC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;CACC,cAAc;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;;AAE3B;;;;AAIA;EACE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;CACtB,gBAAgB;AACjB;;;AAGA;AACA,eAAe;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,yBAAyB;;CAE5B,WAAW;CACX,gBAAgB;GACd,wBAAwB;CAC1B,gBAAgB;AACjB,YAAY;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;CACtB,gBAAgB;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;CACvC,eAAe;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,2BAA2B,EAAE;EACnC,OAAO,wBAAwB,EAAE;AACnC;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;KACK,mBAAmB;IACpB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,sBAAsB;CACzB,WAAW;AACZ;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;CACrB,mBAAmB;AACpB;;AAEA;IACI,WAAW;IACX,mHAAmH;IACnH,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,sCAAsC;IACtC,UAAU,GAAG,0CAA0C;IACvD,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB,GAAG,uDAAuD;AAChF;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,KAAK,wBAAwB,EAAE;IAC/B,MAAM,2BAA2B,EAAE;IACnC,OAAO,wBAAwB,EAAE;AACrC;;;;AAIA;EACE,aAAa;EACb,uBAAuB,EAAE,sBAAsB;EAC/C,6BAA6B;EAC7B,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,YAAmB;EAAnB,cAAmB;EAAnB,qBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;;;AAIA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,mBAAmB,EAAE,4CAA4C;EACjE,2BAA2B,EAAE,+CAA+C;EAC5E,6BAA6B;EAC7B,aAAa;EACb,SAAS,EAAE,wBAAwB;CACpC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,0DAA0D;EAC/E,uBAAuB;EACvB,YAAY,EAAE,qCAAqC;AACrD;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,SAAS,EAAE,yCAAyC;AACtD;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,WAAW,EAAE,sDAAsD;EACnE,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;;AAGA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,YAA0B;CAA1B,cAA0B;CAA1B,4BAA0B;AAC3B;;AAEA;CACC,YAAmB;CAAnB,cAAmB;CAAnB,qBAAmB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;;AAGA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,YAA4B;CAA5B,cAA4B;CAA5B,8BAA4B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;CACC,YAAqB;CAArB,cAAqB;CAArB,uBAAqB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;CACC,YAAqB;CAArB,cAAqB;CAArB,uBAAqB;AACtB;;AAEA;CACC,YAAoB;CAApB,cAAoB;CAApB,sBAAoB;AACrB;;AAEA;CACC,YAAoB;CAApB,cAAoB;CAApB,sBAAoB;AACrB;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;;AAIA;EACE,mBAAmB;;EAEnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;AAEA;EACE,gBAAgB;EAChB,MAAM;CACP,yBAAyB;AAC1B;;;AAGA;;CAEC,yBAAyB;AAC1B;;;AAGA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;AACA,eAAe;;IAEX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;;AAGA;CACC,yBAAyB;EACxB,gBAAgB;EAChB,MAAM,EAAE,gCAAgC;AAC1C;;;AAGA;;CAEC,yBAAyB;AAC1B;;AAEA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;AACA,eAAe;;IAEX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;;IAEhB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;AAC1B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;AAEA;EACE,gBAAgB;EAChB,MAAM;CACP,yBAAyB;AAC1B;;AAEA;AACA,eAAe;;IAEX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;;CAEC,yBAAyB;AAC1B;;;AAGA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;AAC9B;;AAEA;GACG,cAAc;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B,QAAQ;AACR;;AAEA;AACA,eAAe;IACX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;CACP,yBAAyB;AAC1B;;;;AAIA;;CAEC,yBAAyB;AAC1B;;AAEA;AACA,YAA4B;AAA5B,cAA4B;AAA5B,8BAA4B;AAC5B;;AAEA;AACA,cAAc;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;CACC,eAAe;AAChB;;;;AAIA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;;AAGA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;CACf,eAAe;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB,aAAa;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;KACK,eAAe;IAChB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;GACjB,MAAM;CACR,gBAAgB;;AAEjB;;AAEA;;IAEI,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;CAChC,gBAAgB;IACb,MAAM;IACN,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;CACC,YAAY;IACT,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;CAClB,iBAAiB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;CACpB,oBAAoB;AACrB;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ,CAAC;;;CAGA;;;AAGD;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;;AAEA;EACE,aAAa;EACb,kCAAkC;IAChC,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;CAClC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;IACI,sBAAsB;MACpB,yBAAyB;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB,yBAAyB;KACtB,sCAAsC;CAC1C;;AAED;IACI,yBAAyB;KACxB,cAAc;;;AAGnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;;CAEC,gBAAgB;CAChB,mBAAmB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;CACjB,aAAa;AACd;;AAEA;EACE,SAAO;CACR,gBAAgB;CAChB,mBAAmB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;CACC,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;CACnB,6BAA6B;;AAE9B;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;CACZ,gCAAgC;CAChC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;IACI,yBAAyB;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;;AAGA;AACA,8BAA8B;GAC3B;;AAEH;IACI,eAAe;;IAEf,gBAAgB;IAChB,cAAc;CACjB,iBAAiB;KACb,kBAAkB;IACnB,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf,yBAAyB;AACzB;;AAEA;IACI,cAAc;CACjB,yBAAyB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;KACK,mBAAmB;CACvB,mBAAmB;EAClB,6BAA6B;AAC/B;;AAEA;GACG,2BAA2B;;AAE9B;;;AAGA;KACK,kBAAkB;EACrB,yBAAyB;GACxB,gBAAgB;EACjB,MAAM;AACR;;;AAGA;KACK,eAAe;;AAEpB;;AAEA;IACI,aAAa;AACjB,oEAAoE;CACnE,SAAS;IACN,YAAY;EACd,mBAAmB;AACrB;;;;AAIA;GACG,0BAA0B;EAC3B,UAAU;;AAEZ;;;AAGA;;CAEC,yBAAyB;AAC1B;;;;AAIA;IACI,gBAAgB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;IACI,yBAAyB;IACzB,aAAa;CAChB,kBAAkB;IACf,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;CACnB,mBAAmB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;;;;AAKA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;CAEC,YAAY;AACb;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB,EAAE,4BAA4B;AAC1D;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;;AAIA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;CACC,kBAAkB;IACf,2BAA2B;IAC3B,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;KACK,kBAAkB;IACnB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,WAAW;;IAEX,gBAAgB;IAChB,WAAW;IACX,yBAAyB;GAC1B,sBAAsB;;AAEzB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;;IAEvB,gBAAgB;IAChB,WAAW;GACZ,sBAAsB;;AAEzB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;;IAEf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;CACrB,mBAAmB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;CACrB,iBAAiB;CACjB,oBAAoB;AACrB;;;AAGA;KACK,gBAAgB;CACpB,mBAAmB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;;IAEf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;CACrB,mBAAmB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;;IAEf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;CACrB,mBAAmB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;;AAGA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;KACrB,YAAY;IACb,sBAAsB;MACpB,mCAAmC;CACxC,6BAA6B;CAC7B,eAAe;;AAEhB,gBAAgB;AAChB;;;;;;AAMA;IACI,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wCAAwC;AACrE;;;AAGA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;CACC,YAA0B;CAA1B,cAA0B;CAA1B,4BAA0B;AAC3B;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;CACC,YAA4B;CAA5B,cAA4B;CAA5B,8BAA4B;AAC7B;;AAEA;EACE,eAAe;AACjB;;;AAGA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;KACrB,YAAY;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;CACtC,6BAA6B;CAC7B,eAAe;;AAEhB,gBAAgB;CACf,WAAW;AACZ;;;;AAIA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;KACrB,YAAY;IACb,sBAAsB;IACtB,gBAAgB;CACnB,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;;AAGA;IACI,yBAAyB;CAC5B;;;AAGD;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB,eAAe;CACd,kBAAkB;;AAEnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,4BAA4B;CAC5B,aAAa;AACd;;AAEA;AACA,wBAAwB;CACvB,aAAa;CACb,yBAAyB;CACzB,aAAa;AACd;;AAEA;;CAEC,aAAa;AACd","sourcesContent":["@charset \"utf-8\";\n\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n  border: none;\n  margin: 0;\n  padding: 0;\n   \n}\n\npre,\nfieldset,\ntable {\n  border: 0;\n}\n\ntable, td {width: 100%;\nborder: 1px solid #707070;}\n\n\nh1,\nh2,\nh3 {\n  margin: 0;\n  padding: 0;\n   \n\tmargin-bottom: 10px; \n}\n\nh1 {\nfont-size: 20px;\n \nfont-weight: 400;\n}\n\n\nh2 {\n  font-size: 15px;\n   \nfont-weight: 500;\n}\n\n\nh3 {\n  font-size: 15px;\n   \nfont-weight: 300;\n}\n\n\n.color-accent,\n.color-accent-hover:hover,\n.color-accent-hover:focus,\n:root .has-accent-color,\n.has-drop-cap:not(:focus):first-letter,\n.wp-block-button.is-style-outline,\na {\n  color: #707070;\n}\n\n\n.welcome-header\n{\n\tline-height: 60px;\n\tvertical-align: middle;\n\tpadding-left: 28px;\t\n}\n\n.company-pages {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.content-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.first {\n\twidth: 200px;\n}\n\n\n.second {\n\twidth: calc(100% - 220px);\n}\n\n.first-smaller {\n\twidth: 70px;\n}\n\n\n.second-smaller {\n\twidth: calc(100% - 200px);\n}\n\n.third-smaller {\n\twidth: 60px;\n}\n\n.mission-text {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.button-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n\n.company-pages textarea {\n    padding: 10px;\n    margin-bottom: 20px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-sizing: border-box;\n\theight: 300px;\n}\n\n.press-pages {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.presslist {\n    padding-bottom: 50px;\n}\n\n\n.section-header, .input-section, .button-section {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n\tmargin-bottom: 0px;\n}\n\n\n.input-section h2 {\n\tmargin-bottom: 0px;\n}\n\n.input-section input, .input-section select {\n\twidth: 200px;\n\tpadding: 5px;\n\tmargin-left: 5px;\n}\n\n\n\n.save {\n    background: #ececef;\n    color: #353740;\n    padding: 9px 13px;\n    border-radius: 8px;\n    border: none; \n    transition: transform 0.3s;\n    cursor: pointer;\n    font-size: 14px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    letter-spacing: normal;\n    margin-left: 3px;\n\tmargin-right: 3px;\n}\n\n.save:hover {\n    background: #e2e2e7;\n}\n\n\n\n.tiny_button {\n    color: #0028FF;\n    padding: 2px 5px;\n    border: none; \n    transition: transform 0.3s;\n    cursor: pointer;\n    font-size: 13px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    letter-spacing: normal;\n    margin-left: 3px;\n\tmargin-right: 3px;\n}\n\n.tiny_button:hover {\n    color: #000000;\n}\n\n\n\n.editor-button {\n    background: linear-gradient(145deg, #0028FF, #0038FF); \n    color: #ffffff;\n    padding: 7px 11px;\n    border-radius: 5px;\n    border: none; \n    transition: transform 0.3s;\n    cursor: pointer;\n    font-size: 17px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n    letter-spacing: normal;\n    margin-left: 3px;\n\tmargin-right: 3px;\n}\n\n.editor-button:hover {\n    transform: scale(1.04);\n}\n\n.collaborators-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  border-collapse: collapse;\n  width: 100%;\n  font-family: 'Arial', sans-serif;\n}\n\n.collaborators-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px;\n  border-bottom: 5px solid #f4f4f4;\n  background-color: #FFFFFF;\n}\n\n.collaborators-list li:hover {\n  background-color: #f4f4f4;\n}\n\n.collaborators-list li span {\n  margin-right: 10px;\n  color: #333;\n  font-size: 14px;\n}\n\n\n.pending {\n  background-color: #fff3cd;\n}\n\n.rewrite {\n  background-color: #cce5ff;\n}\n\n.commented {\n  background-color: #d4edda;\n}\n\n.collaborated {\n  background-color: #f8d7da;\n}\n\n\noption {\n  padding: 5px;\n}\n\n\n.press-pages textarea {\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-sizing: border-box;\n\theight: 150px;\n}\n\n.save1 {\n    display: inline-block;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #0028ff;\n    color: #0028ff;\n    background: #ffffff;\n    cursor: pointer;\n    position: relative;\n    z-index: 0;\n    border-radius: 5px;\n    font-size: 15px;\n    transition: background .3s ease-in-out;\n    padding: 5px 15px 5px 15px;\n\tmargin-right: 10px;\n}\n\n\n\n.blueButton {\n    display: inline-block;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #0028ff;\n    color: #ffffff;\n    background: #0028ff;\n    cursor: pointer;\n    position: relative;\n    z-index: 0;\n    border-radius: 5px;\n    font-size: 15px;\n    transition: background .3s ease-in-out;\n    padding: 5px 15px 5px 15px;\n\tmargin-right: 10px;\n}\n\n.blueButton:hover {\n   \n    color: #0028ff;\n    background: #ffffff;\n  \n}\n\n\n\n.save-active {\n    display: inline-block;\n    text-decoration: none;\n    text-align: center;\n    border: 1px solid #0028ff;\n    color: #0028ff;\n    background: #e0e0e0;\n    cursor: pointer;\n    position: relative;\n    z-index: 0;\n    border-radius: 5px;\n    font-size: 15px;\n    transition: background .3s ease-in-out;\n    padding: 5px 15px 5px 15px;\n\tmargin-right: 10px;\n}\n\n.save1:hover {\ncolor: #ffffff;\n   background: #0028ff;\n\n}\n\n.vertical-center {\n\tdisplay: flex; \n\talign-items: center;\n}\n\nlabel {\n  font-size: 14px;\n  font-weight: 300;\n\t\t\t \n}\n\ninput[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n}\n\n.icons button {\n\tbackground-color: transparent;\n\tborder: 0px;\n\tcursor: pointer;\n}\n\n.icons button:hover {\n\topacity: 0.3;\n}\n\n\n\n.icons img {\n\theight: 15px;\n\twidth: auto;\n}\n\n.icons .enabledButton:hover {\n\topacity: 0.3;\n}\n\n\np {\n\tline-height: 1.4;\n    font-weight: 300;\n    display: block;\n    margin-block-start: 0em;\n    margin-block-end: 0em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n\n}\n\n\np.small {\n  font-size: 15px;\n}\n\np.big {\n  font-size: 20px;\n}\n\n\n.header-item span {\n      font-size: 18px;\n\tline-height: 1.4;\n  font-weight: 300;\n \n}\n\n.creator-info span {\n  font-size: 15px;\n  line-height: 1.4;\n  font-weight: 300;\n  display: block;\n}\n\nli,\na,\nli a {\n  color: #707070;\n  font-weight: 300;\n  text-decoration: none;\n  \nlist-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\na:hover,\nli a:hover {\n  text-decoration: none;\n\t\t\t \n\n}\n\ntd {\n    padding-right: 7px;\n\t  vertical-align: middle;\n\t  font-size: 18px;\n\tline-height: 1.4;\n\tfont-weight: 300;\n  \t \n\n}\n\n\n\n\n.headerbar {\n  display: grid;\n  position: fixed;\n  top: 0px;\n\tleft: 150px;\n  z-index: 100;\n  height: 60px;\n  width: 100%;\n  background-color: #ffffff;\n  font-weight: 400;\n    font-size: 18px;\n\tline-height: 1.4;\n  visibility: visible;\nborder-bottom: thin #DBDBDB solid;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,.1);\n}\n\n.leftpart {\n  height: 100%; \n}\n\n.middlepart {\n  height: 100%; \n}\n\n.rightpart {\n  height: 100%; \n}\n\n.headerbar li {\n  position: relative;\n  display: inline;\n  color: #ffffff;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 28px;\n}\n\n.headerbar p {\n  position: relative;\n  display: inline;\n  color: #ffffff;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 28px;\n    font-size: 14px;\n\tline-height: 1.4;\n}\n\n\n.headerbar li a {\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.headerbar li a:hover {\n  color: #ffffff;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.headerbar a {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.headerbar a:hover {\n  text-decoration: underline;\n}\n\n\n\n\n\n.bottombar {\n  position: fixed;\n  bottom: 0;\n  z-index: 100;\n  min-height: 40px;\n  padding: 10px 5% 10px;\n  width: 90%;\n  background-color: #ffffff;\n  font-weight: 400;\n  font-size: 15px;\n  visibility: visible;\n  align-content: center;\n  text-align: center;\n}\n\n.bottombar li {\n  position: relative;\n  display: inline;\n  color: #707070;\n  margin: 0 3px;\n  padding: 0 2px 4px;\n  line-height: 30px;\n}\n\n.bottombar li a {\n  color: #707070;\n  font-size: 14px;\n}\n\n.bottombar li a:hover {\n  color: #707070;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.bottombar a {\n  color: #707070;\n  text-decoration: none;\n}\n\n.bottombar a:hover {\n  text-decoration: underline;\n}\n\n\n.content-background {\n  position: absolute;\n  left: 140px;\n  right: 0px;\n  z-index: 99;\n  top: 40px;\n\tbottom: 0px;\n}\n\n.content {\n  position: absolute;\n  left: 20px;\n  right: 10px;\n  z-index: 99;\n  top: 30px;\n\tbottom: 30px;\n }\n\n.inner {\n   background-color: #ffffff;\n\tbox-shadow: 0 2px 4px 0 rgba(220,220,220,.5);\nborder: thin #DBDBDB solid;\n\toverflow: auto;\n\tscroll-behavior: auto;\n\tpadding: 25px;\n\theight: calc(100% - 50px);\n}\n\n.sub-inner {\n  margin-bottom: 10px; \n\tbackground-color: #ffffff;\n\tbox-shadow: 0 2px 4px 0 rgba(220,220,220,.5);\nborder: thin #DBDBDB solid;\n\toverflow: auto;\n\tscroll-behavior: auto;\n\tpadding:15px;\n}\n\n.sub-inner textarea\n{\n\t    width: 100%;\n    min-height: 70px;\n    max-height: 95px;\n    padding: 3px;\nborder: 1px solid #DBDBDB;\n\tresize: none;\n    box-sizing: border-box;\n    overflow-y: auto;\n    transition: height 0.2s ease-in-out; \n\ttransition: border-color 0.3s;\n\tfont-size: 15px;\n\t   \nfont-weight: 300;\n\tcolor: #333;\n}\n\n\n.editor-textarea:focus,\n.editor-input:focus {\n    border: 1px solid #0028ff;\n    outline: none;\n}\n\n.sub-inner input\n{\n\tmargin-bottom: 4px;\n\tmargin-right: 4px;\n\tmax-width: 60%;\n}\n\n.sub-inner select\n{\n\tmargin-bottom: 4px;\n\tmargin-right: 4px;\n\tmax-width: 60%;\n}\n\n.full-width {\n    width: calc(100% - 50px);\n    float: left;\n}\n\n.half-width {\n    width: 50%;\n    float: left;\n}\n\n.one-thirds {\n    width: calc(100% - 60% - 104px);\n    float: right;\n}\n\n.two-thirds {\n    width: 60%;\n    float: left;\n\tmargin-right: 20px;\n}\n\n\n#chat-history {\n            flex: 2;\n             padding: 3px 5px;\n  font-size: 20px;\n  border: solid 1px;\n  border-color: #707070;\n  margin-top: 10px;\n\t bottom: 50px;\n\t max-height: 450px;\n          overflow-y: scroll;\n\t\n\toverflow-anchor: none;\n        }\n\n\nul {\n  display: block;\n  list-style-type: disc;\n  margin: 0;\n  padding-inline-start: 0;\n}\n\n\n.logo {\n  top: 20px;\n  left: 15px;\n  width: 120px;\n  position: fixed;\n  z-index: 1001;\n}\n\n\n.logo img {\n\twidth: 100%;\n\theight: auto;\n}\n\n.language-switcher {\n  position: fixed;\n  right: 60px;\n  top: 15px;\n\theight: 20px;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n.user {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n\theight: 20px;\n\twidth: 20px;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n\n.user:before {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  filter: blur(0px);\n  width: calc(100% + 3px);\n  height: calc(100% + 3px);\n  background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);\n  background-size: 200%;\n  animation: glowing 20s linear infinite;\n  opacity: 0;\n  z-index: -1;\n  border-radius: 0px;\n}\n\n.user:hover {\n  color: #707070;\n  text-decoration: none;\n}\n\n.user:hover:before {\n  opacity: 1;\n  filter: blur(10px);\n}\n\n.user img {\n  height: 100%;\n  width: auto;\n}\n\n.dropdown-content {\n  position: absolute;\n  right: 30px;\n  top: 50px;\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n  transform: translateY(-20px);\n  transition: all 0.5s ease, opacity 0.3s ease;\n  opacity: 0;\n  visibility: hidden;\n  border: 1px solid #ddd;\n  z-index: 170707000000;\n}\n\n\n.dropdown-content.slide-in {\n  transform: translateY(0);\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Dropdown Section */\n.dropdown-section {\n  padding: 15px;\n  display: flex;\n  flex-direction: column; /* Aligns items vertically */\n  gap: 5px; /* Adds space between items */\n}\n\n\n.dropdown-section a {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  border-radius: 4px;\n  text-align: center;\n  text-decoration: none;\n  color: #333;\n  font-size: 14px;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.dropdown-section a:hover {\n  background-color: #e6e6e6;\n  color: #707070;\n}\n\n.dropdown-section a.active {\n  background-color: #d3d3d3;\n  color: #707070;\n}\n\n.dropdown-section:last-child {\n  border-bottom: none;\n}\n\n.dropdown-section-bottom button {\n  background-color: #ffffff;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  font-size: 15px;\n  color: #333;\n  transition: background-color 0.3s;\n\tcursor: pointer;\n\tfont-weight: 400;\n}\n\n.dropdown-section-bottom button:hover {\n  background-color: #eaeaea;\n}\n\n.dropdown-section-bottom a {\n  background-color: #ffffff;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  font-size: 15px;\n  color: #333;\n  transition: background-color 0.3s;\n\tcursor: pointer;\n\tfont-weight: 400;\n}\n\n.dropdown-section-bottom a:hover {\n  background-color: #eaeaea;\n}\n\n\n.half td {\n\tmin-width: 0px;\n}\n\n.main-nav-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 150px;\n  padding-top: 60px; \n  z-index: 999; \n  height: 100%; \n  border-right: 1px solid #e0e0e0;\n  background-color: #ffffff;\n}\n\n.main-nav, .one, .two, .three {\n  position: relative;\n  left: 0;\n  z-index: 1001;\n  width: 150px;\n}\n\n.one, .two, .three {\n  padding-top: 20px; \n  margin-bottom: 10px;\n}\n\n.main-nav a {\n  font-size: 13px;\n  color: #333;\n  padding: 10px 15px;\n  margin: 3px 5px;\n  border-radius: 4px;\n  display: block;\n  transition: all 0.3s ease;\n   \n}\n\n\n\n.main-nav a:hover, .main-nav .active {\n  color: #0028ff; \n  background-color: #e0e0e0;\n  border-right: 4px solid #0028ff;\n  text-decoration: none;\n\tfont-weight: 300;\n}\n\n\n.main-nav button.main-nav-disabled {\nfont-size: 13px;\n    color: #0028ff;\n    padding: 10px 15px;\n    margin: 3px 5px;\n    border-radius: 4px;\n    display: block;\n    transition: all 0.3s ease;\n     \n\tborder: 0px;\n\tfont-weight: 300;\n\t  width: calc(100% - 10px);\n\ttext-align: left;\nopacity: 0.5;\n}\n\n.main-nav button.main-nav-disabled:hover {\n  color: #0028ff; \n  background-color: #e0e0e0;\n  border-right: 4px solid #0028ff;\n  text-decoration: none;\n\tfont-weight: 300;\n}\n\n.main-nav .active:hover {\n  color: #ffffff; \n  background-color: #0028ff;\n  border-right: 4px solid #e0e0e0;\n  text-decoration: none;\n}\n\n.main-nav button {\n  font-size: 13px;\n  color: #0028ff;\n  background-color: transparent;\n  border: 1px solid #e0e0e0;\n  padding: 5px 2px;\n  width: calc(100% - 30px);\n  margin: 2px 20px;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n\tcursor: pointer;\n}\n\n.main-nav button:hover {\n  color: #0028ff;\n  background-color: #e0e0e0;\n  border-color: #e0e0e0;\n}\n\n@keyframes glowing {\n  0% { background-position: 0 0; }\n  50% { background-position: 400% 0; }\n  100% { background-position: 0 0; }\n}\n\n   \n.tab-controls {\n    display: flex; \n    flex-direction: column; \n    align-items: flex-start; \n    border-bottom: 0px solid #d3d3d3;\n}\n\n.tab-controls button {\n     background: #FFFFFF;\n    color: #333333;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: 1px solid #d3d3d3; \n    transition: transform 0.3s;\n    cursor: pointer;\n    font-size: 13px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    letter-spacing: normal;\n\tmargin: 3px;\n}\n\n\n.tab-controls button:hover {\n    background-color: #e6e6e6;\n}\n\n.tab-controls button.active {\n    background-color: #d3d3d3; \n    color: #ffffff;\n}\n\n.tab-controls button.active:hover {\n    background-color: #cccccc;\n}\n\n\n\n.glowing {\n    display: inline-block;\n    text-decoration: none;\n    text-align: center;\n    line-height: 40px;\n    min-width: 160px;\n    height: 40px;\n    border: 1px solid #707070;\n    color: #707070;\n    background: #fff;\n    cursor: pointer;\n    position: relative;\n    z-index: 0;\n    border-radius: 10px;\n    font-size: 15px;\n    transition: background .3s ease-in-out;\n    padding-left: 10px;\n\tpadding-right: 10px;\n}\n\n.glowing:before {\n    content: '';\n    background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);\n    position: absolute;\n    top: -2px;\n    left:-2px;\n    background-size: 400%;\n    z-index: -1;\n    filter: blur(5px);\n    width: calc(100% + 4px);\n    height: calc(100% + 4px);\n    animation: glowing 20s linear infinite;\n    opacity: 1;  /* Adjusted this to always show the glow */\n    border-radius: 10px;\n}\n\n.glowing:active {\n    color: #707070;\n}\n\n.glowing:hover:before {\n    filter: blur(20px);  /* Adjusted this to increase the glow spread on hover */\n}\n\n.glowing:after {\n    z-index: -1;\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    left: 0;\n    top: 0;\n    border-radius: 10px;\n}\n\n@keyframes glowing {\n    0% { background-position: 0 0; }\n    50% { background-position: 400% 0; }\n    100% { background-position: 0 0; }\n}\n\n\n\n.publicapproval-header, .publicapproval-item {\n  display: flex;\n  align-items: flex-start; /* Updated this line */\n  border-bottom: 0px solid #ccc;\n  padding: 0px 5px 0px 5px;\n  gap: 20px;\n}\n\n.publicapproval-header .header-item:first-child, .publicapproval-item > div:first-child {\n  flex: 0 0 calc(60%);\n  height: 500px;\n  overflow-y: auto;\n  padding-right: 15px;\n}\n\n.publicapproval-header .header-item:nth-child(2), .publicapproval-item > div:nth-child(2) {\n  flex: 0 0 calc(40% - 25px);\n}\n\n\n\n.modal-alert {\n  display: flex;\n  flex-direction: column; /* Changes layout to vertical */\n  align-items: center; /* Horizontally centers items in the alert */\n  justify-content: flex-start; /* Aligns items to the start of the container */\n  border-bottom: 0px solid #ccc;\n  padding: 25px;\n  gap: 25px; /* Space between items */\n\tbackground-color: #ffffff;\n\tborder-radius: 8px;\n}\n\n.modal-alert-item {\n  display: flex;\n  align-items: center; /* Center items vertically within each .modal-alert-item */\n  justify-content: center;\n  width: 350px; /* Sets a fixed width for each item */\n}\n\n/* Maintains the spacing between buttons if they are in the same .modal-alert-item */\n.modal-alert-item > div {\n  display: flex;\n  gap: 10px; /* Adjust the space between the buttons */\n}\n\n\n.modal-alert-backdrop {\n  position: fixed;\n  top: 0;\n  left: 150px; /* Adjusted from 150px to 0 to cover the full screen */\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n\n\n.companydetails-header, .companydetails-item {\n  display: flex;\n  align-items: center;\n  border-bottom: 0px solid #ccc;\n  padding: 0px 5px 0px 5px;\ngap: 5px;\n}\n\n\n.companydetails-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.companydetails-header .header-item:first-child, .companydetails-item > div:first-child {\n flex: 0 0 calc(40% - 15px);\n}\n\n.companydetails-header .header-item:nth-child(2), .companydetails-item > div:nth-child(2) {\n flex: 0 0 calc(60%);\n}\n\n\n.companydetails-header-four, .companydetails-item-four {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 5px 5px 5px;\ngap: 5px;\n}\n\n\n.companydetails-item-four:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.companydetails-header-four .header-item:first-child, .companydetails-item-four > div:first-child {\n flex: 0 0 calc(100% - 350px);\n\t text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.companydetails-header-four .header-item:nth-child(2), .companydetails-item-four > div:nth-child(2) {\n flex: 0 0 calc(170px);\n\t text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.companydetails-header-four .header-item:nth-child(3), .companydetails-item-four > div:nth-child(3) {\n flex: 0 0 calc(120px);\n}\n\n.companydetails-header-four .header-item:nth-child(4), .companydetails-item-four > div:nth-child(4) {\n flex: 0 0 calc(15px);\n}\n\n.companydetails-header-four .header-item:nth-child(4), .companydetails-item-four > div:nth-child(4) {\n flex: 0 0 calc(15px);\n}\n\n\n\n\n.press-release-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n\n\n.header-item {\n  padding-bottom: 5px;\n\t     \n\t text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.article-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n\n.article-header, .article-item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 5px 5px 5px;\ngap: 5px;\n}\n\n.article-header {\n  position: sticky;\n  top: 0;\n\tbackground-color: #ffffff;\n}\n\n\n.article-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n\n.article-header .header-item:first-child, .article-item > div:first-child {\n  flex: 0 0 calc(100% - 390px);\n}\n\n.article-header .header-item:nth-child(2), .article-item > div:nth-child(2) {\n  flex: 0 0 90px;\n}\n\n.article-header .header-item:nth-child(3), .article-item > div:nth-child(3) {\n  flex: 0 0 80px;\n}\n\n.article-header .header-item:nth-child(4), .article-item > div:nth-child(4) {\n  flex: 0 0 210px;\n}\n\n.article-header h2 {\nfont-size: 15px;\n     \n    font-weight: 500;\n    padding: 0;\n    margin-bottom: 0px;\n}\n\n\n.press-release-header, .press-release-item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 5px 5px 5px;\ngap: 5px;\n}\n\n\n.press-release-header {\n\tbackground-color: #ffffff;\n  position: sticky;\n  top: 0; /* Adjust this value as needed */\n}\n\n\n.press-release-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.press-release-header .header-item:first-child, .press-release-item > div:first-child {\n  flex: 0 0 calc(100% - 575px);\n}\n\n.press-release-header .header-item:nth-child(2), .press-release-item > div:nth-child(2) {\n  flex: 0 0 90px;\n}\n\n.press-release-header .header-item:nth-child(3), .press-release-item > div:nth-child(3) {\n  flex: 0 0 90px;\n}\n\n.press-release-header .header-item:nth-child(4), .press-release-item > div:nth-child(4) {\n  flex: 0 0 90px;\n}\n\n.press-release-header .header-item:nth-child(5), .press-release-item > div:nth-child(5) {\n  flex: 0 0 80px;\n}\n\n.press-release-header .header-item:nth-child(6), .press-release-item > div:nth-child(6) {\n  flex: 0 0 210px;\n}\n\n.press-release-header h2 {\nfont-size: 15px;\n     \n    font-weight: 500;\n    padding: 0;\n    margin-bottom: 0px;\n}\n\n.translations p, div {\n    font-size: 15px;\n    line-height: 1;\n    font-weight: 300;\n     \n    display: block;\n    margin-block-start: 0em;\n    margin-block-end: 0em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n}\n\n\n.corporatetext-header, .corporatetext-item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 5px 5px 5px;\ngap: 5px;\n}\n\n.blogpost-header {\n  position: sticky;\n  top: 0;\n\tbackground-color: #ffffff;\n}\n\n.corporatetext-header h2 {\nfont-size: 15px;\n     \n    font-weight: 500;\n    padding: 0;\n    margin-bottom: 0px;\n}\n\n.corporatetext-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n\n.corporatetext-header .header-item:first-child, .corporatetext-item > div:first-child {\n  flex: 0 0 calc(100% - 575px);\n}\n\n.corporatetext-header .header-item:nth-child(2), .corporatetext-item > div:nth-child(2) {\n   flex: 0 0 90px;\n}\n\n.corporatetext-header .header-item:nth-child(3), .corporatetext-item > div:nth-child(3) {\n  flex: 0 0 80px;\n}\n\n.corporatetext-header .header-item:nth-child(4), .corporatetext-item > div:nth-child(4) {\n  flex: 0 0 90px;\n}\n\n.corporatetext-header .header-item:nth-child(5), .corporatetext-item > div:nth-child(5) {\n  flex: 0 0 80px;\n}\n\n.corporatetext-header .header-item:nth-child(6), .corporatetext-item > div:nth-child(6) {\n  flex: 0 0 210px;\n}\n\n\n\n\n.blogpost-header, .blogpost-item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 5px 5px 5px;\ngap: 5px;\n}\n\n.blogpost-header h2 {\nfont-size: 15px;\n    font-weight: 500;\n    padding: 0;\n    margin-bottom: 0px;\n}\n\n.blogpost-header {\n  position: sticky;\n  top: 0;\n\tbackground-color: #ffffff;\n}\n\n\n\n.blogpost-item:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n.blogpost-header .header-item:first-child, .blogpost-item > div:first-child {\nflex: 0 0 calc(100% - 390px);\n}\n\n.blogpost-header .header-item:nth-child(2), .blogpost-item > div:nth-child(2) {\nflex: 0 0 90px;\n}\n\n.blogpost-header .header-item:nth-child(3), .blogpost-item > div:nth-child(3) {\n  flex: 0 0 80px;\n}\n\n.blogpost-header .header-item:nth-child(4), .blogpost-item > div:nth-child(4) {\n flex: 0 0 210px;\n}\n\n\n\n.blogpost-item > div {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.corporatetext-item > div {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.press-release-item > div {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.article-item > div {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.shorten {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%; \n}\n\n\n.modal-backdrop-edit {\n    position: fixed;\n    top: 50px;\n    left: 120px;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100000000;\n}\n\n.modal-edit-content {\n    background: white;\n    padding: 20px;\n    border-radius: 5px;\n    max-width: 80%;\n    width: 100%;\n}\n\n.modal-content {\n    background: white;\n    padding: 20px;\n    border-radius: 5px;\n    max-width: 600px;\n    width: 100%;\n}\n\n\n.modal-backdrop-full {\n    position: fixed;\n    top: 0;\n    left: 0px;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100000000;\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 150px;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.disabledButton {\n    opacity: 0.3;\n\tcursor: pointer;\n}\n\n.disabledButton button:hover {\n    opacity: 0.3;\n}\n\n.press-modal {\n    position: fixed;\n    top: 0;\n    left: 150px;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-press-content {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    padding: 20px;\n    margin-left: 30px;\n    margin-right: 30px;\n    margin-top: 120px;\n    margin-bottom: 60px;\n    text-align: left;\n    overflow-y: auto;\n\t display: flex;\n    flex-direction: column;\n    max-height: 80vh;\n}\n\ntextarea:disabled {\n\t    cursor: default;\n    background-color: #ffffff;\n    color: #000000;\n    border-color: #ffffff;\n}\n\n.sticky {\n\tposition: sticky;\n\tpadding: 8px;\n\tborder-radius: 8px;\n\tfont-size: 13px;\n\tfont-weight: 500;\n\tbackground-color: #ffffff;\n\tfont-color: #0028FF;\n\t  top: 0; \n\tmax-width: 130px;\n\n}\n\n.modal-button-bar {\n \n    justify-content: space-between;\n    background: #ffffff;\n    padding-bottom: 10px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    border-bottom: 1px solid #ddd;\n\tposition: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.modal-scrollable-content {\n    overflow-y: auto;\n    flex-grow: 1;\n    padding: 10px;\n}\n\n.modal-header, .modal-body, .modal-footer {\n    padding: 10px;\n}\n\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n}\n\n.close-press-button {\n\tfloat: right;\n    background: none;\n    border: none;\n    font-size: 44px;\n    cursor: pointer;\n\tmargin-top: -12px;\n}\n\n.modal-body {\n    text-align: left;\n}\n\n.press-release-date {\n    font-style: italic;\n    margin-bottom: 10px;\n}\n\n.press-release-text {\n    line-height: 1.6;\n}\n\n.modal-footer {\n    text-align: left;\n    margin-top: 20px;\n    border-top: 1px solid #eee;\n    padding-top: 10px;\n\tpadding-bottom: 30px;\n}\n\n\n\n.subscription-container {\n    max-width: 600px;\n    margin: auto;\n    text-align: center;\n    font-family: 'Arial', sans-serif;\n}\n\n.toggle-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n    margin: 0 10px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: .4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    transition: .4s;\n}\n\ninput:checked + .slider {\n    background-color: #0028FF;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #0028FF;\n}\n\ninput:checked + .slider:before {\n    transform: translateX(26px);\n}\n\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n\n\n@media only screen and (max-width: 766px) {\n\n\n.plans-container {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 5px;\n}}\n\t\n\t\n\t@media only screen and (min-width: 767px) {\n\n\n.plans-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 5px;\n}\n\n}\n\t\n.plan {\n\t display: grid;\n  grid-template-rows: 50px 50px 50px;\n    padding: 25px 10px 10px 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    transition: transform 0.3s ease;\n\ttext-align: center;\n\tmargin: 5px;\n}\n\n.plan:hover {\n    transform: scale(1.05);\n    \t border: 1px solid #0028ff;\n}\n\n.plan h3 {\n    margin: 0 0 10px 0;\n}\n\n.plan button {\n    background-color: #0028ff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 15px;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 5px;\n\t border: 1px solid #0028ff;\n\t    transition: background-color 0.7s ease;\n\t}\n\n.plan button:hover {\n    background-color: #ffffff;\n\t    color: #0028ff;\n   \n\n}\n\n.inactive {\n    color: #aaa;\n}\n\n.active {\n    font-weight: bold;\n}\n\n\n.left\n{\n\ttext-align: left;\n\talign-content: left;\n}\n\n\n.vision-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.vision-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.vision-content {\n  gap: 20px;\n}\n\n.vision-content textarea {\n  margin-top: 10px;\n\theight: 150px;\n}\n\n.vision-instructions, .vision-text, .vision-button {\n  flex: 1;\n\tmargin-top: 10px;\n\tmargin-bottom: 20px;\n}\n\n\n.content-section, .translations-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.translation-header, .translation-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.translation-row {\n\tpadding-top: 10px;\n\tborder-top: 1px solid #ddd;\n}\n\n.content-section {\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\tmargin-bottom: 30px;\n\tborder-bottom: 1px solid #ddd;\n\n}\n\n.translations {\n    width: calc(100% - 20px);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n\tborder-bottom: 1px solid #dddddd;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n}\n\n.first-translations, .second-translations, .third-translations {\n    display: flex;\n    flex-direction: column;\n    justify-content: center; \n    gap: 10px;\n}\n\n.first-translations {\n    width: 120px;\n\t overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.second-translations {\n    width: calc(100% - 230px);\n\t overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.third-translations {\n width: 90px;\n\ttext-align: right;\n}\n\n\n.toggle-translations {\nborder-left: 1px solid #ffffff;\n   }\n\n.toggle-translations-btn {\n    font-size: 12px;\n     \n    font-weight: 500;\n    color: #0028ff;\n\tmargin-right: 2px;\n     border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    text-align: center;\n    display: inline-block;\n    margin: 0px;\nborder: 1px solid #ffffff;\n}\n\n.toggle-translations-btn:hover {\n    color: #707070;\n\tborder: 1px solid #707070;\n}\n\n.toggle-translations-btn:focus {\n    outline: none;\n}\n\n.initial-info {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    padding: 10px;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 10px;\n}\n\n.info-header {\n    font-weight: bold;\n    text-align: center;\n}\n\n.info-value {\n    text-align: center;\n}\n\n\n\n.table-comments {\n     margin-bottom: 10px;\n\tpadding-bottom: 5px;\n  border-bottom: 1px solid #ccc;\n}\n\n.table-row-comments {\n  \tgrid-template-columns: 100%; \n\n}\n\n\n.table {\n     margin-bottom: 0px;\n  background-color: #ffffff;\n\t  position: sticky;\n  top: 0;\n}\n\n\n.table p {\n     font-size: 15px;\n\t\n}\n\n.table-header, .table-row {\n    display: grid;\ngrid-template-columns: 10px calc(100% - 400px) 100px 80px 50px 110px; \n\tgap: 10px;\n    padding: 5px;\n  align-items: center; \n}\n\n\n\n.table-row {\n   border-top: 1px solid #ccc;\n\t\tz-index: 1;\n\n}\n\n\n.table-row:hover\n{\n\tbackground-color: #F5F5F5;\n}\n\n\n\n.header-approval, .header-collaboration {\n    text-align: left;\n\tfont-weight: 400;\n\tpadding-bottom: 5px;\n}\n\n.row-approval {\n  display: block;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n\n.row-collaboration {\n  display: block;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n\n.detailed-info {\n    background-color: #f4f4f4;\n    padding: 10px;\n\tpadding-right: 5px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-top: 10px;\n\tmargin-bottom: 10px;\n}\n\n.detailed-info h4 {\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.creator-info, .approvers-section, .comments-section {\n    margin-bottom: 20px;\n}\n\n.approvers-section select {\n    width: 150px;\n}\n\n\n.approvers-list, .comments-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.approvers-list li, .comments-list li {\n    background-color: white;\n    padding: 10px;\n    border-radius: 5px;\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.approvers-list li.approved {\n    border-left: 4px solid #0028ff;\n}\n\n.approvers-list li.pending {\n    border-left: 4px solid orange;\n}\n\n\n\n\n.send-reminder-btn, .send-approval-requests-btn {\n    background-color: #707070;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.send-reminder-btn:hover, .send-approval-requests-btn:hover {\n    background-color: #333333;\n}\n\n.divider\n{\n\theight: 20px;\n}\n\n\n.status-circle {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 5px;\n}\n\n.status-circle.approved {\n    background-color: #0028ff;\n}\n\n.status-circle.not-approved {\n    background-color: orange;\n}\n\n.status-circle.pending {\n    background-color: orange; /* or any color you prefer */\n}\n\n\n.status-circle.collaborated {\n    background-color: #0028ff;\n}\n\n.status-circle.not-collaborated {\n    background-color: orange;\n}\n\n\n.corporatetext-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n\n\n.input-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.input-group label {\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: var(--text-color);\n}\n\n.input-group input, .input-group textarea {\n    padding: 10px;\n    border: 1px solid var(--input-border-color);\n    border-radius: 4px;\n    background-color: var(--input-background);\n}\n\n.action-buttons {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.process-button {\n    background-color: var(--primary-color);\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.process-button:hover {\n    background-color: darken(var(--primary-color), 10%);\n}\n\n.process-button:disabled {\n    background-color: #ccc;\n}\n\n.loading-spinner {\n    border: 4px solid rgba(0,0,0,0.1);\n    border-radius: 50%;\n    border-top-color: var(--primary-color);\n    width: 40px;\n    height: 40px;\n    animation: spin 2s linear infinite;\n    margin: 20px auto;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.main-editor-container {\n position: relative;\n    height: calc(100vh - 160px);\n    overflow: hidden;\n\n}\n\n.scrollable-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow-y: hidden;\n    margin-bottom: 80px;\n}\n\n.editor-header, .editor {\n    overflow-y: auto;\n}\n\n.editor-wrapper {\n     position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n\n}\n\n.editor-result {\n    position: relative;\n    width: 100%;\n     \n    font-weight: 300;\n    border: 0px;\n    height: calc(100% - 35px);\n   box-sizing: border-box;\n\n}\n\n.editor-result-full {\n    position: relative;\n    width: calc(100% - 5px);\n     \n    font-weight: 300;\n    border: 0px;\n   box-sizing: border-box;\n\n}\n\n\n.editor-result-text {\n    position: relative;\n    width: 100%;\n    font-size: 20px;\n     \n    font-weight: 300;\n    border: 0px;\n    height: calc(100% - 10px);\n    padding-bottom: 55px;\n    box-sizing: border-box;\n    line-height: 1.5em;\n\tpadding-right: 15px;\n}\n\n.review {\n    font-size: 15px;\n    font-weight: 300;\n    box-sizing: border-box;\n    line-height: 1.5em;\n\tmax-height: 250px;\n\tpadding-bottom: 30px;\n}\n\n\n.review .headline {\n     font-weight: 500;\n\tmargin-bottom: 15px;\n}\n\n\n.editor-approver-text {\n    position: relative;\n    width: 100%;\n    font-size: 20px;\n     \n    font-weight: 300;\n    border: 0px;\n    height: 370px;\n    box-sizing: border-box;\n    line-height: 1.5em;\n\tpadding-right: 15px;\n}\n\n\n.editor-collaborator-text {\n    position: relative;\n    width: 100%;\n    font-size: 20px;\n     \n    font-weight: 300;\n    border: 0px;\n    height: 450px;\n    box-sizing: border-box;\n    line-height: 1.5em;\n\tpadding-right: 15px;\n}\n\n\n.editor-header {\n    text-align: center;\n    padding-bottom: 20px;\n}\n\n\n.editor-content {\n    position: sticky;\n    bottom: 0;\n}\n\n.editor-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 10px; \n}\n\n.editor-input {\n    width: 100%;\n    padding: 0px;\n    border: 0px solid #ccc;\n     resize: none;\n    box-sizing: border-box;\n      transition: height 0.2s ease-in-out; \n\ttransition: border-color 0.3s;\n\tfont-size: 20px;\n\t   \nfont-weight: 500;\n}\n\n\n\n\n\n.editor-input:focus {\n    border: 0px solid #0028ff;\n    outline: none;\n}\n\n\n.editor-textarea:focus {\n    border: 1px solid #0028ff;\n    outline: none;\n}\n\n.editor-section input:focus {\n    border: 1px solid #0028ff;\n    outline: none;\n}\n\n.editor-section-button {\n    flex-basis: 20%;\n    display: flex;\n    justify-content: center; /* Align button in the available space */\n}\n\n\n.textarea-container {\n    flex-grow: 1; \n    width: 40%;\n}\n\n.textarea-container-two:first-child {\n flex: 0 0 calc(50% - 70px);\n}\n\n.textarea-container-two:nth-child(2) {\n  flex: 0 0 calc(50% - 70px);\n}\n\n.textarea-container-two:nth-child(3) {\n  flex: 0 0 120px;\n}\n\n.textarea-container-one:first-child {\n flex: 0 0 calc(100% - 120px);\n}\n\n.textarea-container-one:nth-child(2) {\n  flex: 0 0 120px;\n}\n\n\n.public-comment-textarea {\n    width: 100%;\n    min-height: 70px;\n    height: 300px;\n    padding: 3px;\n    border: 1px solid #ccc;\n     resize: none;\n    box-sizing: border-box;\n    overflow-y: auto;\n    transition: height 0.2s ease-in-out; \n\ttransition: border-color 0.3s;\n\tfont-size: 15px;\n\t   \nfont-weight: 300;\n\tcolor: #333;\n}\n\n\n\n.comment-textarea {\n    width: 100%;\n    min-height: 105px;\n    padding: 3px;\n    border: 1px solid #ccc;\n     resize: none;\n    box-sizing: border-box;\n    overflow-y: auto;\n\ttransition: border-color 0.3s;\n\tfont-size: 15px;\n\tfont-weight: 300;\n\tcolor: #333;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n}\n\n\n.comment-textarea:focus {\n    border: 1px solid #0028FF;\n }\n\n\n::-webkit-scrollbar {\n    width: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: #0028ff;\n    border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: #0028ff;\n}\n\n\n\n.editor-textarea::placeholder {\n    color: #909090;\n}\n\n.editor-result-text::placeholder {\n    color: #0028ff;\n    font-weight: 300;\nfont-size: 20px;\n\tline-height: 1.5em;\n\t   \n}\n\ntextarea {\n  resize: none;\n\t outline: none;\n}\n\n.span-added {\n\tcolor: #0028ff; \n\tfont-weight:bold; \n\tpadding:0 4px;\n\tborder: 1px solid #0028ff;\n}\n\n.span-removed {\n\tbackground-color:#ccc; \n\tcolor:#0028ff; \n\ttext-decoration:line-through; \n\tpadding:0 4px;\n}\n\n.span-changed {\nbackground-color:#ffff99; \n\tcolor:#cc9900; \n\ttext-decoration:underline; \n\tpadding:0 4px;\n}\n\n.span-else {\n\n\tpadding:0 2px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
